/* eslint-disable jsx-a11y/control-has-associated-label */
// Old code brought from the legacy checkout flow.
import React from 'react';

import { EventForUser, EventGuest } from 'legacy/events/types';
import {
  useFriendRequestCommandsForSuggestedFriends,
  useGetMe
} from 'legacy/user/hooks';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import { useEventGuestListSearch } from 'legacy/search/hooks';
import UserImage from 'legacy/user/components/UserImage';
import Loader from 'legacy/common/components/layout/Loader';
import { useTranslation } from 'react-i18next';

type GuestSuggestionsProps = {
  event: EventForUser;
};

const GuestSuggestions: React.FC<GuestSuggestionsProps> = ({ event }) => {
  const { t } = useTranslation(['checkout', 'common']);
  const { data: user } = useGetMe();
  const friendRequestCommands = useFriendRequestCommandsForSuggestedFriends({
    eventId: event._id
  });

  const {
    data: guests,
    isLoading: isLoadingGuests,
    refetch: refetchGuestList
  } = useEventGuestListSearch(false, event._id, '');

  const renderFriendAction = (guest: EventGuest) => {
    const friendStatus = guest.friendStatus;

    const { sendFriendRequestCommand } = friendRequestCommands;

    if (friendStatus === 'requestable') {
      return (
        <Button
          type={ButtonType.Clear}
          className="bg-[#EFF2FF]! rounded-full!"
          disabled={sendFriendRequestCommand.isLoading}
          onClick={() => {
            sendFriendRequestCommand.mutate(guest._id, {
              onSuccess: () => {
                refetchGuestList();
              }
            });
          }}
          data-testid={`button-send-friend-request-${guest._id}`}
        >
          <p className="mt-1 text-sm text-[#3853C4]">
            {t('common:buttons.add')}
          </p>
        </Button>
      );
    }

    if (friendStatus === 'requestSent') {
      return (
        <Button
          type={ButtonType.Clear}
          data-testid={`button-send-friend-request-${guest._id}`}
        >
          <p className="mt-1 text-sm text-gray-400">
            {t('checkout:requested')}
          </p>
        </Button>
      );
    }

    return null;
  };

  if (
    !guests?.pages?.length ||
    !guests.pages.some((page) => page?.some((guest) => guest.id !== user?._id))
  ) {
    return null;
  }

  return (
    <div className="mb-10">
      <Loader isOverlay isLoading={isLoadingGuests}>
        <p className="text-lg font-semibold">
          {t('checkout:getToKnowTheGuestList')}
        </p>

        <div className="mt-4 grid grid-cols-3 gap-x-4 gap-y-6">
          {guests?.pages?.map((page, pageIndex) =>
            page
              ?.filter(
                (guest) =>
                  guest.id !== user?._id &&
                  guest.name !== 'Complimentary Ticket'
              )
              .map((guest, guestIndex) => (
                <div
                  className="flex flex-col items-center"
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${guest._id}-${pageIndex}-${guestIndex}`}
                >
                  <a
                    href={`/profile/${guest._id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block border-4 border-[#EFF2FF] rounded-full w-28 h-28 overflow-hidden"
                  >
                    <UserImage
                      src={guest.photo?.url}
                      className="block w-28 h-28"
                    />
                  </a>
                  <p className="mt-2 text-sm font-semibold text-center">
                    {guest.firstName}
                    <br />
                    {guest.lastName}
                  </p>
                  <div className="mt-3 w-full">{renderFriendAction(guest)}</div>
                </div>
              ))
          )}
        </div>
      </Loader>
    </div>
  );
};

export default GuestSuggestions;
